import { ChangeDetectorRef, Component, Inject, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { SchedulerService } from '../scheduler.service';
import { NextApptWhenEnum } from 'src/app/models/enum/notification/next-appt-when.enum';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { PatientService } from '../../patient/patient.service';
import { DialogService } from '../../../services/dialog.service';
import { StaticDataService } from '../../../services/static-data.service';
import { DoctorsService } from '../../../services/doctors.service';
import { Globals } from '../../../globals';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AppointmentDialogDataV2Model } from '../models/edit-appoitment-data-model';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { PatientHaltDialogComponent } from '../../../dialog/patient-halt-dialog/patient-halt-dialog.component';
import { PatientDataModel } from '../../../models/patient/patient-data.model';
import { PatientSearchModel } from '../../../models/patient/patient-search.model';
import { AppointmentDetailDataModel } from '../../../models/appointments/appointment-detail-data.model';
import { DoctorQueryOptionsModel } from '../../../models/doctors/doctor-query-options.model';
import { AppointmentDataModel } from '../models/appoitment-model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { formatDate } from '@angular/common';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { PatientDialogDataModel } from '../../patient/patient-dialog-data.model';
import { PatientEditComponent } from '../../patient/patient-edit/patient-edit.component';
import { ToothUiManagerModel } from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { OperatoryDataModel } from '../../../models/clients/operatory-data.model';
import { TdoPatientSearchComponent } from '../../../tdo-controls/tdo-patient-search/tdo-patient-search.component';
import { EditAppointmentSelectProcedureDialogComponent } from '../edit-appointment-select-procedure-dialog/edit-appointment-select-procedure-dialog.component';
import { ApptStatusEnum } from 'src/app/models/enum/appt-status.enum';
import { UiService } from 'src/app/services/ui.service';


@Component({
    selector: 'app-edit-appointment-dialog',
    templateUrl: './edit-appointment-dialog.component.html',
    styleUrls: ['./edit-appointment-dialog.component.scss']
})
export class EditAppointmentDialogComponent implements OnInit, AfterViewInit {
    @ViewChild('searchInput') patientInputSearch: TdoPatientSearchComponent;


    constructor(private readonly schedulingService: SchedulerService,
                private readonly fileService: FileManagerService,
                private readonly patientService: PatientService,
                private readonly dialogService: DialogService,
                private readonly staticDataService: StaticDataService,
                private readonly doctorsService: DoctorsService,
                private readonly globals: Globals,
                @Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataV2Model,
                private readonly dialogRef: MatDialogRef<EditAppointmentDialogComponent>,
                private readonly dialog: MatDialog,
                private readonly changeDetectorRef: ChangeDetectorRef,
                private readonly uiService: UiService) { }


    public isLoading: boolean = false;

    isNewAppoitment: boolean = true;

    isAppointmentDoNotAllowEdit = false;
    isAppointmentConfirmation = false;
    isAppointmentDoNotAllowEditNotes = true;
    isAppoitmentDoNotAllowProcEdit = false;

    patientPictureSrc: string = 'assets/Images/defaultPatient.PNG';
    SearchFor: string;
    patient: PatientDataModel;
    isWaitList: boolean = false;
    isOverrideSms: boolean = false;
    patientAppointments: AppointmentDataModel[] = [];

    toothSurfaceEnums: EnumValidValueItemModel[] = [];

    isAllDoctors: boolean = false;
    doctorPredicate: (data: DoctorDataModel) => string;
    userPredicate: (data: TdoUserConfigurationModel) => string;
    referringDoctorPredicate: (data: DoctorDataModel) => string;
    NextApptWhenEnum = NextApptWhenEnum;
    isCustomSmsMessage: boolean = false;
    customSmsMessage: string = '';
    originalStartDate: string = '';
    WaitListReason: string = '';


    providerDoctors: DoctorDataModel[] = [];
    locationDoctors: DoctorDataModel[] = [];
    referringDoctors: DoctorDataModel[] = [];




    enumDoctorType_Provider: string = '00000004-1000-0000-0000-000000000001';
    enumApptStatus_Canceled: string = '00000072-0000-0000-0000-000000000007';
    //enumApptStatus_Confirmed: string = '00000072-0000-0000-0000-000000000008';
    enumApptStatus_UnConfirmed: string = '00000072-0000-0000-0000-0000000000011';
    enumApptType_BlockIn: string = '00000071-0000-0000-0000-000000000006';
    enumApptType_BlockOut: string = '00000071-0000-0000-0000-000000000005';


    ngAfterViewInit(): void {
        // console.log("ngAfterViewInit");
    }

    ngOnInit(): void {

      this.isWaitList= false;

        console.log('The data on init ', this.data);

        this.isAppointmentDoNotAllowEdit = false;
        this.isAppointmentDoNotAllowEditNotes = false;

        if (this.data.cancellingAppointment === true || this.data.appointment.enumApptStatusId === this.enumApptStatus_Canceled) {
            this.isAppointmentDoNotAllowEdit = true;
            this.isAppointmentDoNotAllowEditNotes = false;

            if (this.data.cancellingAppointment === true) {
                this.data.appointment.enumApptStatusId = this.enumApptStatus_Canceled;
            }
        }
        if (this.data.appointment.PatientCaseId == null || this.data.appointment.PatientCaseId == '') {

            this.isAppoitmentDoNotAllowProcEdit = false;
        }
        else {
            this.isAppoitmentDoNotAllowProcEdit = true;
        }

        if (this.data.confirmingAppointment === true) {
            this.isAppointmentDoNotAllowEdit = true;
            this.isAppointmentDoNotAllowEditNotes = false;

            if (this.data.confirmingAppointment === true) {
                this.data.appointment.enumApptStatusId = ApptStatusEnum.Confirmed;
            }
        }

        if (this.data.appointment.AppointmentId) {
            // EDITING:  load patient info
            //           load all else

            if (this.data.appointment.isReservation === true) {

                if (this.data.appointment.PatientId == null || this.data.appointment.CaseProcedureId == null) {
                    this.isNewAppoitment = true;
                }

            }
            else {
                this.isNewAppoitment = false;
            }


            if (this.data.appointment.dataAppoitmentDetails.length == 0) {
                this.schedulingService.getAppoitmnetDetailes(this.data.appointment.AppointmentId).subscribe(res => {
                    this.data.appointment.dataAppoitmentDetails = res;

                  let z = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'isWaitListReason');
                  if(z) {
                    this.isWaitList = true;
                    this.WaitListReason = z.DetailParameterValue;
                  }

                });
            }

            this.onPatientSearchSelectionChanged({ PatientId: this.data.appointment.PatientId } as PatientSearchModel);

        }
        this.originalStartDate = this.data.appointment.startDate;
        this.referringDoctors = this.data.allDoctors;
        this.referringDoctorPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName + ', ' + data.dataContact.FirstName + (data.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001' ? '  (TDO)' : '  (REF)');
        this.doctorPredicate = (data) => 'Dr. ' + data.dataContact.LastName;
        this.setupValidValues();

    }
    private setupValidValues(): void {
        this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');

        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isActiveOnly = true;
        doctorQueryModel.isIncludeReferring = false;
        doctorQueryModel.LOCID = parseInt(this.data.currentLocationId);
        this.doctorsService.getDoctorsForDoctorLocationV2(doctorQueryModel).subscribe((locationDoctors) => {

            this.locationDoctors = locationDoctors;
            this.providerDoctors = locationDoctors;

            if (this.providerDoctors.length == 1) {
                if (!(this.data.appointment?.Label_DoctorId)  )
                {
                    this.data.appointment.Label_DoctorId = this.providerDoctors[0].DoctorId;
                }
            }
        });

    }

    // patient search autocomplete
    displayFn(patient: any): string {
        if (patient && patient.FirstName && patient.LastName) {
            return patient.FirstName + ' ' + patient.LastName;
        }
        return '';
    }

    onPatientSearchSelectionChanged(e: PatientSearchModel) {
        const _patient = e;

        if (!_patient) {
            return;
        }
        this.data.appointment.PatientId = _patient.PatientId;
        if (this.data.appointment.PatientId) {
            this.patientService.getPatient(this.data.appointment.PatientId).subscribe((userRes) => {
                this.data.appointment.PatientName = userRes.ThePatient.dataContact.FirstName + ' ' + userRes.ThePatient.dataContact.LastName;
                this.data.appointment.PatientFullInfo = '{\"FirstName\": \"' + userRes.ThePatient.dataContact.FirstName + '\", \"LastName\": \"' + userRes.ThePatient.dataContact.LastName + '\" }';

                this.fileService.getPatientPicture(this.data.appointment.PatientId).subscribe((res) => {
                    if (res) {
                        this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
                    } else {
                        this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
                    }
                });
                if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                    const config = new MatDialogConfig();
                    config.data = userRes.ThePatient;
                    config.panelClass = 'dialog';

                    this.dialog.open(PatientHaltDialogComponent, config).afterClosed().subscribe((res) => {
                        if (res) {
                            this.loadSelectedPatient(userRes.ThePatient, null);
                        }
                    });
                } else {
                    this.loadSelectedPatient(userRes.ThePatient, null);
                }
            });

            this.patientAppointments = [];
            this.schedulingService.getAllPatientAppointments(this.globals.TDOCID, this.data.appointment.PatientId).subscribe((res) => {
                this.patientAppointments = res;
                // this.appointmentTable.updateData(this.patientAppointments);
            });
        }
    }

    loadSelectedPatient(patient: PatientDataModel, user: PatientSearchModel) {
        this.patient = patient;
        this.data.appointment.PatientId = this.patient.PatientId;
        // this.data.appointment.dataAppoitmentDetails=[];
        //this.isWaitList = false;
        this.isOverrideSms = false;
        this.changeDetectorRef.detectChanges();

        const preferred = this.patient.dataContact.dataContactComms.filter(p => p.isPreferred);
        for (const pref of preferred) {
            switch (pref.enumCommMethodID) {
            case '00000009-1000-0000-0000-000000000004':
                // EMAIL
                let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendEmail');
                if (detail) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail = new AppointmentDetailDataModel();
                    detail.DetailParameterName = 'sendEmail';
                    detail.DetailParameterValue = 'true';
                    detail.AppointmentId = this.data.appointment.AppointmentId;

                    this.data.appointment.dataAppoitmentDetails.push(detail);
                }


                this.changeDetectorRef.detectChanges();


                break;
            case '00000009-1000-0000-0000-000000000003':
                // MOBILE
                let detail1 = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendSMS');
                if (detail1) {
                    detail1.DetailParameterValue = 'true';
                } else {
                    detail1 = new AppointmentDetailDataModel();
                    detail1.DetailParameterName = 'sendSMS';
                    detail1.DetailParameterValue = 'true';
                    detail1.AppointmentId = this.data.appointment.AppointmentId;
                    this.data.appointment.dataAppoitmentDetails.push(detail1);
                }

                this.changeDetectorRef.detectChanges();

                break;
            }
        }

        if (user) {
            this.data.appointment.PatientId = user.PatientId;
        }


        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isIncludeTdo = true;
        doctorQueryModel.isIncludeReferring = true;
        doctorQueryModel.PatientId = this.data.appointment.PatientId;
        this.doctorsService.getDoctors(doctorQueryModel).subscribe((allDoctors) => {

            this.data.allDoctors = allDoctors;
            const detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');

            if (detail == null) {
                this.patientService.getPatientReferringDoctor(this.data.appointment.PatientId).subscribe((res) => {
                    if (res && res.DoctorId && this.data.appointment) {
                        let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
                        if (detail) {
                            detail.DetailParameterValue = res.DoctorId;
                        } else {
                            detail = new AppointmentDetailDataModel();
                            detail.DetailParameterName = 'Referring_DoctorId';
                            detail.DetailParameterValue = res.DoctorId;
                            detail.AppointmentId = this.data.appointment.AppointmentId;
                            if (this.data.appointment.dataAppoitmentDetails) {
                                this.data.appointment.dataAppoitmentDetails = [];
                            }
                            this.data.appointment.dataAppoitmentDetails.push(detail);
                        }
                    }
                });
            }
        });


        this.data.appointment.PatientFullInfo = '{\"FirstName\": \"' + this.patient.dataContact.FirstName + '\", \"LastName\": \"' + this.patient.dataContact.LastName + '\" }';

        this.SearchFor = null;

    }


    launchPatientDetails() {
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
        dm.title = 'Edit Patient';
        // dm.initWebId = true;
        dm.entityId = this.patient.PatientId;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '562px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.patientDeleted) {
                    // Patient was deleted, close the appointment dialog
                    this.dialogRef.close({ patientDeleted: true });
                    return;
                }
                
                console.log(result);
                const patientInfo = JSON.parse(this.data.appointment.PatientFullInfo);
                patientInfo.FullName = `${result.ThePatient.dataContact.FirstName} ${result.ThePatient.dataContact.LastName}`;
                this.data.appointment.PatientFullInfo = JSON.stringify(patientInfo);
                this.patient = result.ThePatient;

                this.loadSelectedPatient(result.ThePatient, null);
            }
        }, err => {
            console.log(err);
        });
    }

    getPatientPhoneNumber() {
        if (this.patient) {
            const phoneNums = this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Phone || p.enumCommMethodID === CommMethodEnum.Mobile);
            if (phoneNums.length > 0) {
                const preferred = phoneNums.find(p => p.isPreferred);
                if (preferred) {
                    return preferred.Address;
                } else {
                    return phoneNums[0].Address;
                }
            }
        }

        return '';
    }
    gotoPatientLedger() {

    }

    // onNewPatientClick() {
    //     this.dialogService.openPatientDialog(null).afterClosed().subscribe((res) => {
    //         if (res) {
    //             this.loadSelectedPatient(res, null);
    //         }
    //     });
    // }
    onNewPatientClickV2() {

        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
        dm.title = 'New Patient';
        // dm.initWebId = true;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '562px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {

            if (!result) {
                return;
            }

            // let  p: PatientSearchModel  = new PatientSearchModel() ;
            // p.PatientId = result.PatientId ;
            //
            // this.onPatientSearchSelectionChanged(p);

            this.onPatientSearchSelectionChanged({PatientId: result.ThePatient.PatientId} as PatientSearchModel);

            // this.patientService.getPatient(result.ThePatient.PatientId).subscribe((userRes) => {
            //     if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
            //         const config1 = new MatDialogConfig();
            //         config1.data = userRes.ThePatient;
            //         config1.panelClass = 'dialog';
            //
            //         this.dialog.open(PatientHaltDialogComponent, config1).afterClosed().subscribe((res) => {
            //             if (res) {
            //                 this.loadSelectedPatient(userRes.ThePatient, null);
            //             }
            //         });
            //     } else {
            //         this.loadSelectedPatient(userRes.ThePatient, null);
            //     }
            // });

        }, err => {
        });
    }



    getReferringDoctor() {

        if (!this.patient) {
            return;
        }

        const details = this.data.appointment.dataAppoitmentDetails;
        if (!details) {
            this.data.appointment.dataAppoitmentDetails = [];
        }
        if (details) {
            const detail = details.find(p => p.DetailParameterName === 'Referring_DoctorId');
            if (detail) {
                const foundDoctor = this.data.allDoctors.find(doctor => doctor?.DoctorId?.toLowerCase() === detail.DetailParameterValue);
                if (foundDoctor) {
                    // this.triggerChangeDetection();
                    const prd = this.patient.dataPatientDoctors.filter(d => d.isReferring === true);
                    this.referringDoctors = this.data.allDoctors.filter(p =>
                        prd.find(f => f.DoctorID === p.DoctorId) ||
                        p.enumDoctorTypeID === this.enumDoctorType_Provider
                    );
                    this.referringDoctors = this.referringDoctors.sort((a, b) => a.enumDoctorTypeID.localeCompare(b.enumDoctorTypeID));
                    // console.log('ref doc', foundDoctor);
                    return foundDoctor;
                }
                else {
                    return null;
                }
            } else {
                const r = this.patient.dataPatientDoctors.find(p => p.isReferring);
                if (r) {
                    const ref = new AppointmentDetailDataModel();
                    ref.DetailParameterName = 'Referring_DoctorId';
                    ref.DetailParameterValue = r.DoctorID;
                    ref.AppointmentId = this.data.appointment.AppointmentId;
                    this.data.appointment.dataAppoitmentDetails.push(ref);

                    const prd = this.patient.dataPatientDoctors.filter(d => d.isReferring === true);
                    this.referringDoctors = this.data.allDoctors.filter(p =>
                        prd.find(f => f.DoctorID === p.DoctorId) ||
                        p.enumDoctorTypeID === this.enumDoctorType_Provider
                    );
                    this.referringDoctors = this.referringDoctors.sort((a, b) => a.enumDoctorTypeID.localeCompare(b.enumDoctorTypeID));

                    return this.data.allDoctors.find(p => p.DoctorId.toLowerCase() === r.DoctorID.toLowerCase());
                }
            }

            this.referringDoctors = this.data.allDoctors;
            return null;
        }

    }

    onReferringDoctorChange(event: TdoDropdownChange) {
        const doc = event.value as DoctorDataModel;
        let ref = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
        if (!ref && doc) {
            ref = new AppointmentDetailDataModel();
            ref.DetailParameterName = 'Referring_DoctorId';
            ref.DetailParameterValue = doc.DoctorId;
            ref.AppointmentId = this.data.appointment.AppointmentId;
            this.data.appointment.dataAppoitmentDetails.push(ref);
        } else {
            if (doc) {
                ref.DetailParameterValue = doc.DoctorId;
            }
        }
    }


    clearReferring() {
        const exists = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
        if (exists) {
            exists.DetailParameterValue = null;
        }


        this.referringDoctors = [];
        this.changeDetectorRef.detectChanges();
        this.referringDoctors = this.data.allDoctors;


    }

    getDate(d: Date | string) {
        // console.log('To Convert: ', d)  ;
        return new Date(d);

    }

    onAppointmentDateChange(event: Date) {

        console.log('date time changed ', event);

        const combinedDateTime = this.getCombineDateTime(new Date(event), new Date(this.originalStartDate), true); // new Date(year, month, day + 1, hours, minutes, seconds);
        const combinedDateTimeEnd = this.getCombineDateTime(new Date(event), new Date(this.data.appointment.endDate), true); // new Date(year, month, day + 1, hoursEnd, minutesEnd, secondsEnd);

        this.data.appointment.startDate = formatDate(combinedDateTime, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
        this.data.appointment.endDate = formatDate(combinedDateTimeEnd, 'yyyy-MM-ddTHH:mm:ss', 'en-US');

    }
    getCombineDateTime(dateObject: Date, timeObject: Date, fixDay: boolean) {
        // Extract date components from dateObject
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth();
        const day = fixDay ? dateObject.getDate() + 1 : dateObject.getDate();

        // Extract time components from timeObject
        const hours = timeObject.getHours();
        const minutes = timeObject.getMinutes();
        const seconds = timeObject.getSeconds();

        return new Date(year, month, day, hours, minutes, seconds);

    }


    onStartDateChange(event) {
        this.originalStartDate = formatDate(event, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
        this.data.appointment.startDate = formatDate(this.getCombineDateTime(new Date(this.data.appointment.startDate), new Date(event), false), 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    }
    onEndDateChange(event) {
        this.data.appointment.endDate = formatDate(event, 'yyyy-MM-ddTHH:mm:ss', 'en-US');
    }


    selectAppointmentTooth() {
        this.dialogService.openToothPicker(true).subscribe((res: ToothUiManagerModel[]) => {
            //
            this.data.appointment.Subject = '';
            let i = 0;
            for (const t of res) {
                if (i > 0) {
                    this.data.appointment.Subject += ' ; ';
                }
                this.data.appointment.Subject += '#' + t.toothModel.cfgToothDescriptions[0].Notation;
                if (t.selectedSurfaceIds && t.selectedSurfaceIds.length > 0) {
                    this.data.appointment.Subject += ' (';
                    let id = 0;
                    for (const s of t.selectedSurfaceIds) {
                        if (id > 0) {
                            this.data.appointment.Subject += ',';
                        }
                        this.data.appointment.Subject += this.toothSurfaceEnums.find(p => p.ValidValueItemId.toLowerCase() === s.toLowerCase()).ItemSValue;
                        id++;
                    }
                    this.data.appointment.Subject += ')';
                }
                i++;
            }
        });
    }


    onProcedureClick() {
        if (this.isNewAppoitment === false) {
            return;
        }

        if (this.data.appointment.PatientId == null) {
            this.uiService.displayMessage("error", "Please select a patient first.");
            return;
        }


        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.data;
        config.width = '600px';
        config.height = '900px';

        this.dialog.open(EditAppointmentSelectProcedureDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {

                console.log('closer res ', res);

                if (res.type == 'new') {
                    this.data.appointment.ForProcedure = res.ProcedureName;
                    this.data.appointment.CaseProcedureId = res.CaseProcedureID;
                    this.data.appointment.isExistingCase =  false;
                }
                if (res.type == 'case') {
                    this.data.appointment.PatientCaseId = res.PatientCaseId;
                    this.data.appointment.CaseWorkItemId = res.CaseWorkItemId;
                    this.data.appointment.ForProcedure = res.ProcedureName;
                    this.data.appointment.isExistingCase =  true;

                    if (res.EnumCaseFollowupReason) {
                        if (this.data.appointment.Subject) {
                            this.data.appointment.Subject += ' - ' + res.EnumCaseFollowupReason;
                        }
                        else
                        {
                            this.data.appointment.Subject = res.EnumCaseFollowupReason;
                        }
                    }
                }

            }
        });
    }
    getProcedureName() {
        if (this.data.appointment.CaseProcedureId) {
            const proc = this.data.procedures.find(p => p.CaseProcedureId.toLowerCase() === this.data.appointment?.CaseProcedureId?.toLowerCase());
            if (proc) {
                return proc.ProcedureName;
            }
        }
        else {
            return this.data.appointment.ForProcedure;
        }


        return '';
    }

    getPatientFlagTooltip(flag: string) {


    }
    getPatientFlagImage(flag: string) {

        console.log(flag);
    }
    onAllDoctorsChange(e) {
        this.isAllDoctors = e.checked;
        if (this.isAllDoctors) {
            this.providerDoctors = this.data.allDoctors;
        } else {
            this.providerDoctors = this.locationDoctors;
        }
    }

    getProviderDoctor() {

        // console.log('The provider get doctor ', this.data.appointment.Label_DoctorId);

        if (this.data.appointment?.Label_DoctorId) {
            const dr = this.providerDoctors.find(p => p.DoctorId.toLowerCase() === this.data.appointment?.Label_DoctorId.toLowerCase());
            if (dr) {
                return dr;
            }
        }
        return null;
    }
    onProviderDoctorChange(e) {

        let doc: any = null;

        try {
            doc = e.value as DoctorDataModel;
        } catch (error: unknown) {
            doc = e.value[0] as DoctorDataModel;
        }



        // console.log('The provider doctor cahnge ', doc);
        if (doc) {
            this.data.appointment.Label_DoctorId = doc.DoctorId;
        }
    }

    getOperatory() {
        const op = this.data.operatories.find(p => p.OperatoryId?.toLowerCase() === this.data.appointment?.OperatoryId?.toLowerCase());
        if (op) {
            return op;
        }
        return null;
    }
    onOperatoryChange(e) {
        const op = e.value as OperatoryDataModel;
        this.data.appointment.OperatoryId = op.OperatoryId;
    }
    onSecondaryOperatoryChange(e) {
        if (!e.isUserInput) {
            return;
        }
        this.data.appointment.secondaryOperatorys = [];
        for (const op of e.value as OperatoryDataModel[]) {
            this.data.appointment.secondaryOperatorys.push(op.OperatoryId);
        }

    }
    getAdditionalOpsList() {
        return this.data.operatories.filter(p => p?.OperatoryId?.toLowerCase() !== this.data.appointment?.OperatoryId?.toLowerCase());
    }

    getSecondOperatories() {

    }
    onSecondOperatoryClosed(e) {

    }
    checkDetailBool(detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            const detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (detail) {
                return detail.DetailParameterValue === 'true';
            }
        }
    }
    onDetailChange(event: MatCheckboxChange, detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.AppointmentId = appt.AppointmentId;
                detail.DetailParameterName = detailName;
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
            }
        }

    }
    onEarlierAppointment(e) {
        this.isWaitList = e.checked;
        console.log('visible this.isWaitList', this.isWaitList);
        if (this.isWaitList === false) {
            this.WaitListReason = '';
            this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');

        }
    }

    onEarlierAppointmentReason(event: string) {
        this.WaitListReason = event;
        this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');
    }



    checkDetailValueBool(detailName: string, value: string) {

    }
    onDetailValueChange(check: boolean, value: string, detailName: string) {

        // console.log(`onDetailValueChange ${detailName}` ,check, value );
        value = value != '' ? value : null;
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.AppointmentId = appt.AppointmentId;
                detail.DetailParameterName = detailName;
                detail.DetailParameterValue = check ? value : null;
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                detail.DetailParameterValue = check ? value : null;
            }
            // console.log(`onDetailValueChange ${detailName} detail` , detail);
        }
    }

    onCancellationCallTaskChange(vvid: string, taskCheckbox: MatCheckbox, dateTimeControl: HTMLInputElement) {
        taskCheckbox.checked = true;
        const date = new Date();
        let daysToAdd = 0;

        switch (vvid) {
        case NextApptWhenEnum.NONE:
        case NextApptWhenEnum.CONVENIENCE:
        case NextApptWhenEnum.RECALL:
            daysToAdd = 0;
            break;
        case NextApptWhenEnum.ONE_DAY:
            daysToAdd = 1;
            break;
        case NextApptWhenEnum.TWO_DAYS:
            daysToAdd = 2;
            break;
        case NextApptWhenEnum.THREE_DAYS:
            daysToAdd = 3;
            break;
        case NextApptWhenEnum.THIRTY_DAYS:
            daysToAdd = 30;
            break;
        case NextApptWhenEnum.SIXTY_DAYS:
            daysToAdd = 60;
            break;
        case NextApptWhenEnum.NINETY_DAYS:
            daysToAdd = 90;
            break;
        case NextApptWhenEnum.ONE_WEEK:
            daysToAdd = 7;
            break;
        case NextApptWhenEnum.ONE_AND_HALF_WEEKS:
            daysToAdd = 10;
            break;
        case NextApptWhenEnum.TWO_WEEKS:
            daysToAdd = 14;
            break;
        case NextApptWhenEnum.THREE_WEEKS:
            daysToAdd = 21;
            break;
        case NextApptWhenEnum.SIX_WEEKS:
            daysToAdd = 42;
            break;
        case NextApptWhenEnum.SIX_MONTHS:
            daysToAdd = 180;
            break;
        }

        date.setDate(date.getDate() + daysToAdd);
        const str = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en_US');
        dateTimeControl.value = str;
        this.onDetailValueChange(true, str, 'isAddToCallList');
    }


    onCustomSmsFinished(e) {

    }

    getUser(UserId: string) {

    }

    getProcedureType(CaseProcedureId: string) {
        return '';
    }
    onOverrideSmsMessage(e) {
        this.isOverrideSms = e.checked;
        if (this.isOverrideSms) {
            this.generateSMSMessage();
        }
    }
    generateSMSMessage() {
        let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'customSms');
        if (!detail) {
            detail = new AppointmentDetailDataModel();
            detail.AppointmentId = this.data.appointment.AppointmentId;
            if (this.isOverrideSms) { // if override Sms, delete original from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'originalSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'customSms';
            } else {// if original Sms, delete override sms from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'customSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'originalSms';
            }
            this.data.appointment.dataAppoitmentDetails.push(detail);
        }

        let patientName = '<<Patient Name>>';
        let appointmentDate = '<<Appointment Date>>';
        let doctorName = '<<Doctor Name>>';

        const startTime = new Date(this.data.appointment.startDate).toLocaleDateString();
        appointmentDate = startTime;

        if (this.data.appointment.Label_DoctorId) {
            const doctor = this.returnDoctorById(this.data.appointment.Label_DoctorId);
            if (doctor) {
                doctorName = `Dr. ${doctor.dataContact.FirstName} ${doctor.dataContact.LastName}`;
            }
        }

        if (this.patient) {
            patientName = `${this.patient.dataContact.FirstName}`;
            if (this.patient.dataContact.LastName) {
                patientName += ' ' + `${this.patient.dataContact.LastName}`;
            }
        }

        detail.DetailParameterValue = `Hello ${patientName}, your appointment with ${doctorName} has been scheduled for ${appointmentDate}. You can access the Patient Portal here: ${window.origin}/patientLogin Please check your email for more details. Thank you`;
        this.customSmsMessage = detail.DetailParameterValue;
    }

    returnDoctorById(doctorId: string): DoctorDataModel {
        if (!this.data.allDoctors) {
            return;
        }
        const foundDoctor = this.data.allDoctors.find(doctor => doctorId === doctor?.DoctorId);

        if (foundDoctor) {
            return foundDoctor;
        }
    }

    //  patient search autocomplete ----------------------------------------------


    showBlockAppt() {

        if (this.data.appointment.enumApptTypeId == this.enumApptType_BlockIn  || this.data.appointment.enumApptTypeId == this.enumApptType_BlockOut)
        {
            return true;
        }
        else
        {
            return false;
        }

    }

    onSaveClick() {
        if (this.isNewAppoitment === true) {
            if (!(this.data.appointment.enumApptTypeId == this.enumApptType_BlockIn  || this.data.appointment.enumApptTypeId == this.enumApptType_BlockOut)) {
                if (!this.validateAppointmentFields())
                    return;
            }
            this.data.appointment.isReservation = false;
            this.schedulingService.saveNewAppoitment(this.data.appointment).subscribe(res => {
                // close this dialog
                this.dialogRef.close(res);
            });
        }
        else {
            // update
            if (!this.validateAppointmentFields())
                return;
            this.data.appointment.isReservation = false;
            this.schedulingService.updateAppoitment(this.data.appointment).subscribe(res => {
                // close this dialog
                this.dialogRef.close(res);
            });
        }
    }
    
    validateAppointmentFields(){
        // validate required fileds
        let validationError = '';
        if (!this.data.appointment.PatientId) {
            validationError += 'Patient missing<br/>';
        }

        if (!this.data.appointment.startDate) {
            validationError += 'Start Date Time missing<br/>';
        }

        if (!this.data.appointment.endDate) {
            validationError += 'End Date Time missing<br/>';
        }
        
        if (this.data.appointment.endDate <= this.data.appointment.startDate) {
            console.log('onSaveClick start date ', this.data.appointment.startDate, ' end date ', this.data.appointment.endDate);
            validationError += 'Start Date Time must be grater then End Date Time<br/>';
        }

        if (!this.data.appointment.ForProcedure) {
            validationError += 'Proceure is missing<br/>';
        }

        if (!this.data.appointment.Label_DoctorId) {
            validationError += 'Provider/Doctor is missing<br/>';
        }

        if (validationError != '') {
            this.uiService.displayMessage("error", validationError);
            return false;
        }
        return true;
    }
    onCancelClick() {



        if (this.data.appointment.Reservation_AppointmentId == null) {
            this.dialogRef.close(null);
        }
        else {

            try {

                this.schedulingService.removeAppointmentReservation(this.data.appointment.Reservation_AppointmentId).subscribe(
                    (res) => {

                        if (res != 'OK') {
                            this.uiService.displayMessage("error", res);
                        }
                        this.dialogRef.close(null);
                    }
                );
            }
            catch (e) {
                console.log(e);
                this.uiService.displayMessage("error", "Error removing appointment reservation");
            }
        }
    }
}
